import { render, staticRenderFns } from "./CollaborationCertificate.vue?vue&type=template&id=e9a0869e&scoped=true"
import script from "./CollaborationCertificate.vue?vue&type=script&lang=ts"
export * from "./CollaborationCertificate.vue?vue&type=script&lang=ts"
import style0 from "./CollaborationCertificate.vue?vue&type=style&index=0&id=e9a0869e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a0869e",
  null
  
)

export default component.exports